import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMemberExitSurveysQuery = createQueryHook(
  MembershipsCreatorApiClient.getMemberExitSurveys,
  {
    queryKey: ['memberExitSurveys'],
  },
)
